import React, { Component } from 'react';
import MainProfile from './MainProfile.jsx';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { Button } from '@material-ui/core';
import UpdateProfile from './UpdateProfile.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants.js';
import { Redirect, withRouter } from 'react-router-dom';
import AreYouSureAlert from '../../components/Alert/AreYouSureAlert.jsx';
import { store } from '../../store';
import { RemoveCircle } from '@material-ui/icons';

const styles = theme => ({
    card: {
        color: theme.palette.secondary.main
    }
});
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
class Profile extends Component {
    constructor() {
        super();
        this.state = {
            update: false,
            show_deactivate_alert: false,
            redirectMain: false,
        };
    }

    profileUpdate = () => {
        this.setState({ update: true });
    };
    showProfile = () => {
        this.setState({ update: false });
    };
    updateDone = () => {
        this.setState({ update: false });
        if (this.props.userData.role == ROLE_CUSTOMER) {
            this.props.history.push(`/user/profile`);
        } else if (this.props.userData.role == ROLE_PROVIDER) {
            // this.props.history.push(`/user/dashboard`);
            this.props.history.push(`/provider/dashboard`);
        }
    };

    openModel = () => {
        this.setState({ show_deactivate_alert: true })
        //console.log("test", this.state);
    }
    deactivate = async () => {
        this.props.deactivateAction(
            {
                role: store.getState().auth.userData.role
            },
            this.onDone
        );
    }

    onDone = (success, data) => {
        if (success) {
            console.log(data)
            this.setState({
                //redirectMain: true,
                show_deactivate_alert: false
            });
            this.props.history.push('/');
        }
    };

    render() {
        const { userData } = this.props;
        // if (this.state.redirectMain) {
        //     return <Redirect to={'/'} />;
        // }
        return (
            <div className="tz-2-com tz-2-main h4-padding" id='view_profile'>
                <div>
                    {!this.state.update ? (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.profile"
                                defaultMessage="My Profile"
                            />
                            {
                                (this.props.userData.role == ROLE_PROVIDER) && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            // backgroundColor: '#0078ff',
                                            width: '40%',
                                            margin: '4px 4px',
                                            borderRadius: 5,
                                            cursor: 'pointer',
                                            paddingTop: 20
                                        }}
                                        onClick={this.openModel}

                                    >
                                        <RemoveCircle style={{ marginTop: 10 }} />
                                        <p style={{
                                            marginBottom: 0,
                                            padding: 10,
                                            color: 'red',
                                            fontSize: 17
                                        }}>Delete Account</p>
                                    </div>
                                )
                            }
                            {/* <Button
                                variant="contained"
                                color="primary"
                                onClick={this.profileUpdate}
                            >
                                <FormattedMessage
                                    id="Edit profile"
                                    defaultMessage="Edit profile"
                                />
                            
                            </Button> */}
                        </h4>
                    ) : (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.updateprofile"
                                defaultMessage="Update Profile"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.showProfile}
                            >
                                <FormattedMessage
                                    id="customer.profile"
                                    defaultMessage="View Profile"
                                />
                            </Button>
                        </h4>
                    )}
                </div>
                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <h3>PROFILE.jsx</h3> */}
                            {!this.state.update ? (
                                <MainProfile {...sendProps(this.props)} />
                            ) : (
                                <UpdateProfile
                                    user={userData}
                                    updateDone={this.updateDone}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <AreYouSureAlert
                    open={this.state.show_deactivate_alert}
                    title=""
                    content="You are deativating your account. Do you want to continue?"
                    close={() => this.setState({ show_deactivate_alert: false })}
                    handleYes={this.deactivate}
                    handleNo={() => this.setState({ show_deactivate_alert: false })}
                />
            </div>
        );
    }
}

const composedProfile = compose(withStyles(styles));
export default composedProfile(withRouter(Profile));



// WEBPACK FOOTER //
// ./src/views/User/Profile.jsx